const reservation = {
  namespaced: true,
  state: {
    name: '',
    registNumber: null,
    numberOfPersons: null,
    displayTime: '',
  },
  getters: {
    getReserveInfo: (state) => {
      return state
    },
  },
  mutations: {
    setReserveInfo(state, payload) {
      state.name = payload.name
      state.registNumber = payload.registNumber
      state.numberOfPersons = payload.numberOfPersons
      state.displayTime = payload.displayTime
    },
  },
}

export default reservation
